/* eslint-disable jsx-a11y/anchor-has-content */
import Link from 'next/link';
import { Button, Dialog } from '@ghq-abi/design-system-v2';
import { T, useTranslate } from '@tolgee/react';

import { useUser } from '~/shared/auth/useUser';
import { CloseDialogButton } from '~/shared/components/Ticket/Dialog/close-icon';
import { EUR_CREATE_TICKET_LINK, GQH_CREATE_TICKET_LINK } from '~/shared/constants/sidebar';

type HelpCenterDialogProps = {
  open: boolean;
  setIsHelpCenterDialogOpen: (isOpen: boolean) => void;
};

export function HelpCenterDialog({
  open,
  setIsHelpCenterDialogOpen,
}: HelpCenterDialogProps) {
  const { t } = useTranslate();
  const { zone } = useUser();

  const createTicketLink = zone === 'ZONE EUROPE' ? EUR_CREATE_TICKET_LINK : GQH_CREATE_TICKET_LINK;

  return (
    <Dialog.Root open={open} onOpenChange={setIsHelpCenterDialogOpen}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content className="w-145 max-w-full p-0">
          <div className="flex cursor-default items-center justify-between border-b border-[#EEEFF2] p-4">
            <Dialog.Title className="text-sm font-semibold leading-[160%] text-(--color-text-primary)">
              {t('sidebar.knowledge_center.how_to_create_a_ticket')}
            </Dialog.Title>
            <CloseDialogButton onClick={() => setIsHelpCenterDialogOpen(false)} />
          </div>
          <div className="p-4">
            <h1 className="cursor-default text-xs font-semibold text-[#3F465A]">
              {t('sidebar.knowledge_center.create_incident')}
            </h1>
            <div className="mt-5">
              <p className="mb-5 cursor-default text-sm font-normal text-[#191F2E]">
                <span className="mr-2 inline-block h-6 w-6 rounded px-1.5 text-xs text-[#191F2E] bg-[#F2DC39]">1</span>
                <T
                  keyName="sidebar.knowledge_center.dialog.item1"
                  params={{
                    b: <b />,
                    u: <u />,
                    a: (
                      <a
                        style={{ textDecoration: 'none', color: '#191F2E' }}
                        href={createTicketLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={t('sidebar.knowledge_center.create_a_ticket')}
                      />
                    ),
                  }}
                />
              </p>
              <p className="mb-5 cursor-default text-sm font-normal text-[#191F2E]">
                <span className="mr-2 inline-block h-6 w-6 rounded px-1.5 text-xs text-[#191F2E] bg-[#F2DC39]">2</span>
                <T keyName="sidebar.knowledge_center.dialog.item2" />
              </p>
              <p className="mb-5 cursor-default text-sm font-normal text-[#191F2E]">
                <span className="mr-2 inline-block h-6 w-6 rounded px-1.5 text-xs text-[#191F2E] bg-[#F2DC39]">3</span>
                <T keyName="sidebar.knowledge_center.dialog.item3" />
              </p>
              <p className="mb-5 cursor-default text-sm font-normal text-[#191F2E]">
                <span className="mr-2 inline-block h-6 w-6 rounded px-1.5 text-xs text-[#191F2E] bg-[#F2DC39]">4</span>
                <T keyName="sidebar.knowledge_center.dialog.item4" />
              </p>
            </div>
          </div>
          <div className="flex justify-end gap-4 border-t border-[#EEEFF2] py-4 pl-0 pr-4">
            <Button
              variant="secondary"
              onClick={() => setIsHelpCenterDialogOpen(false)}
            >
              {t('common.cancel')}
            </Button>
            <Link
              target="_blank"
              href="https://abinbevww.service-now.com/abiex?id=sc_cat_item&sys_id=5ad2235adb1cc050f17eb29f29961934"
            >
              <Button variant="primary" className="bg-[#F2DC39]! text-[#191F2E]!">
                {t('sidebar.knowledge_center.create_a_ticket')}
              </Button>
            </Link>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
